import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
} from "recharts";

const Y_TICKS = [0, 30, 60, 90, 120, 150, 180];

const SERIES = [
    {
        key: "co2",
        name: "Emisiones parciales kg CO2",
        color: "#2563eb",
    },
    {
        key: "ch4",
        name: "Emisiones parciales g CH4",
        color: "#8b5cf6",
    },
    {
        key: "n2o",
        name: "Emisiones parciales g N2O",
        color: "#10b981",
    },
];

const GasesLineChartGraph = ({ data, height = 400, yTicks = Y_TICKS }) => {
    const displayData = Array.isArray(data) ? data : [];
    const maxTick = Math.max(...yTicks, 1);

    return (
        <div
            style={{
                width: "100%",
                height,
                position: "relative",
            }}
        >
            <ResponsiveContainer width="100%" height={height}>
                <LineChart
                    data={displayData}
                    margin={{ top: 10, right: 16, left: 0, bottom: 10 }}
                >
                    <CartesianGrid
                        strokeDasharray="3 3"
                        stroke="#f0f0f0"
                    />
                    <XAxis
                        dataKey="name"
                        tick={{ fontSize: 14, fill: "#666" }}
                        axisLine={false}
                        tickLine={false}
                    />
                    <YAxis
                        type="number"
                        domain={[0, maxTick]}
                        allowDataOverflow
                        ticks={yTicks}
                        tick={{ fontSize: 14, fill: "#666" }}
                        axisLine={false}
                        tickLine={false}
                        width={50}
                    />
                    <Tooltip
                        formatter={(value, name) => [
                            `${Number(value).toFixed(2)}`,
                            name,
                        ]}
                        contentStyle={{
                            backgroundColor: "#fff",
                            border: "none",
                            borderRadius: "8px",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                            fontSize: "14px",
                        }}
                        labelStyle={{
                            fontSize: "14px",
                            fontWeight: "600",
                            color: "#333",
                            marginBottom: "8px",
                        }}
                    />
                    {SERIES.map((s) => (
                        <Line
                            key={s.key}
                            type="monotone"
                            dataKey={s.key}
                            name={s.name}
                            stroke={s.color}
                            strokeWidth={2}
                            activeDot={{ r: 6 }}
                            dot={{ r: 3 }}
                        />
                    ))}
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
};

export default GasesLineChartGraph;
